export default __webpack_public_path__ + "static/media/X_icon.d64da92f.svg";